export const COMPANY = {
  legalName: 'Lokyis Ltd',
  productName: 'Dreamly Land',
  supportEmail: 'support@lokyis.com',
  companyEmail: 'admin@lokyis.com',
  website: 'https://lokyis.com',
  // Add only after these details are approved for public display.
  registrationNumber: null,
  registeredOffice: null,
};
